module.exports = __webpack_public_path__ + "internal-bugs-47bbe7850d694af2f2cd76c116925083.webp";